import { render, staticRenderFns } from "./SlideShowImgTwo.vue?vue&type=template&id=36c6c384&scoped=true&"
import script from "./SlideShowImgTwo.vue?vue&type=script&lang=js&"
export * from "./SlideShowImgTwo.vue?vue&type=script&lang=js&"
import style0 from "./SlideShowImgTwo.vue?vue&type=style&index=0&id=36c6c384&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c6c384",
  null
  
)

export default component.exports